import { RenewalPlan } from './renewal-plan';
import { PropertyViewCard } from './property-view-card';

export class RenewalChoosePlan {
    constructor(
        public LeaseRenewalToken: string = '',
        public AccessToken: string = '',
        public LeaseRenewalKey: Number = null,
        public PremierPlan: RenewalPlan = null,
        public PreferredPlan: RenewalPlan = null,
        public FlexiblePlan: RenewalPlan = null,
        public ShowRoommateUpdate: boolean = null,
        public SentEmail: string = '',
        public IsLocked: boolean = true,
        public IsRentToPurchaseLease: boolean = false,
    ) { }
}
